var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuickGlobesvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_874_11400)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z",
    fill: "#A7ADB7"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M9.706 19.996C4.32 19.84 0 15.425 0 10C0 9.90801 0.001 9.81501 0.004 9.72401C0.736 9.79401 2.063 9.95301 2.125 10.467C2.212 11.179 2.125 12.068 2.731 12.335C3.337 12.602 3.511 11.268 4.03 11.624C4.55 11.98 5.934 12.322 5.934 12.951C5.934 13.581 5.674 14.559 5.934 14.737C6.194 14.915 7.232 16.161 7.232 16.339C7.232 16.517 7.598 17.422 7.489 17.767C7.399 18.054 6.943 18.945 6.501 19.35C7.5252 19.7448 8.60886 19.9632 9.706 19.996ZM5.87 0.890012C7.16715 0.301334 8.57552 -0.00216311 10 1.1605e-05C13.902 1.1605e-05 17.281 2.23401 18.93 5.49301C18.966 6.36001 18.96 7.10201 19.151 7.37001C20.126 8.73301 16.777 9.67101 17.286 11.734C17.51 12.644 15.059 12.355 14.46 13.207C13.86 14.059 12.397 13.487 12.058 13.323C11.718 13.159 10.418 13.705 10.532 12.777C10.645 11.85 11.436 11.795 12.284 11.413C13.132 11.032 14.354 9.76301 13.754 9.59801C10.924 8.81801 9.96 6.08801 9.96 6.08801C9.79 6.05401 9.833 4.15701 9.098 4.10201C8.363 4.04801 7.968 4.32001 6.894 4.10201C5.82 3.88401 6.046 3.17501 5.876 1.64701C5.838 1.30501 5.84 1.06401 5.87 0.890012ZM20 9.86301V10C20 15.49 15.576 19.946 10.1 20C15.522 19.945 19.926 15.432 20 9.86301Z",
    fill: "#A7ADB7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_874_11400"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuickGlobesvg);
export default __webpack_public_path__ + "static/media/quick-globe.svg.8718361ae4398a25773fb721256f88df.svg";
export { ForwardRef as ReactComponent };